import styled from "styled-components";

export const SmallPrint = styled.p`
  font-family: ${({ theme }) => theme.fonts.smallPrint.family};
  font-size: ${({ theme }) => theme.fonts.smallPrint.fontSize};
  line-height: ${({ theme }) => theme.fonts.smallPrint.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.smallPrint.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.smallPrint.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  color: ${({ theme }) => theme.colors.typographyDefault};
`;
